// TODO: redesign-dticket - make it reusable across Subscription Pause flow

import { useCallback, useState } from 'react';

export const useDTicketSubscriptionEditPauseInfoModal = () => {
	const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

	const openInfoModal = useCallback(() => {
		setIsInfoModalOpen(true);
	}, []);

	const closeInfoModal = useCallback(() => {
		setIsInfoModalOpen(false);
	}, []);

	return {
		isInfoModalOpen,
		openInfoModal,
		closeInfoModal,
	};
};
